import { cn } from "@/lib/utils";
import { Heart } from "lucide-react";

export function TopHUD({ 
  worldName = "Fruit Garden",
  worldEmoji = "🌸",
  hp,
  maxHP,
  coins = 0,
  gems = 0,
  onHealthClick,
  onCoinsClick,
  onGemsClick
}) {
  return (
    <div 
      className="fixed top-0 left-0 right-0 z-40 safe-area-top"
      data-testid="top-hud"
    >
      {/* Main HUD Bar */}
      <div className="bg-slate-900/90 backdrop-blur-xl border-b border-white/10">
        <div className="flex items-center justify-between px-2 py-2 max-w-lg mx-auto">
          {/* World Name - Left */}
          <button className={cn(
            "flex items-center gap-1.5 px-3 py-1.5 rounded-xl",
            "bg-slate-800/60",
            "border border-white/10",
            "active:bg-slate-700/60 transition-colors"
          )}>
            <span className="text-base">{worldEmoji}</span>
            <span className="text-white font-semibold text-xs truncate max-w-[80px]">{worldName}</span>
          </button>
          
          {/* Resources - Right */}
          <div className="flex items-center gap-1.5">
            {/* Health */}
            <button
              onClick={onHealthClick}
              className={cn(
                "flex items-center gap-1 px-2 py-1.5 rounded-xl",
                "bg-slate-800/60",
                "border border-white/10",
                "active:bg-slate-700/60 transition-colors"
              )}
              data-testid="hud-health"
            >
              <Heart className="w-4 h-4 text-red-500 fill-red-500" />
              <span className="text-white font-bold text-xs">{hp}/{maxHP}</span>
            </button>
            
            {/* Coins */}
            <button
              onClick={onCoinsClick}
              className={cn(
                "flex items-center gap-1 px-2 py-1.5 rounded-xl",
                "bg-slate-800/60",
                "border border-white/10",
                "active:bg-slate-700/60 transition-colors"
              )}
              data-testid="hud-coins"
            >
              <span className="text-sm">🪙</span>
              <span className="text-yellow-400 font-bold text-xs">{formatNumber(coins)}</span>
            </button>
            
            {/* Stars */}
            <button
              onClick={onGemsClick}
              className={cn(
                "flex items-center gap-1 px-2 py-1.5 rounded-xl",
                "bg-slate-800/60",
                "border border-white/10",
                "active:bg-slate-700/60 transition-colors"
              )}
              data-testid="hud-gems"
            >
              <span className="text-sm">⭐</span>
              <span className="text-amber-400 font-bold text-xs">{formatNumber(gems)}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Format large numbers to be more compact (e.g., 1.2M, 500K)
function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return num.toLocaleString();
}
